import {MarkType} from "prosemirror-model";
import {EditorState} from "prosemirror-state";

export const isMarkActive = (markType: MarkType) => (
    state: EditorState
): boolean => {
    const { from, $from, to, empty } = state.selection

    if (empty) {
        return Boolean(markType.isInSet(state.storedMarks || $from.marks()))
    }

    return state.doc.rangeHasMark(from, to, markType)
}
